import { FormsEnum } from "../../../../models/enums/forms.enum";

export class IdWebResponse {

    public status: String;
    public erreurs: Array<String>;

    constructor() {

    }

}

